var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('CustomButton',{on:{"click":_vm.install}},[_vm._v(" Install as app ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }